export default __webpack_public_path__ + "static/media/doc-consult.b3020100.png";